// extracted by mini-css-extract-plugin
module.exports = {"loading-wrapper":"layout_loading-wrapper__FnCJw","loading":"layout_loading__jhx6x","loading-text":"layout_loading-text__3tM8A","headTitle":"layout_headTitle__QjJax"};